exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editable-cell:hover::after {\n  content: '\\270E';\n  font-family: FontAwesome;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n}[dir] .editable-cell:hover::after {\n          transform: translateY(-50%);\n}[dir=ltr] .editable-cell:hover::after {\n  right: 5px;\n}[dir=rtl] .editable-cell:hover::after {\n  left: 5px;\n}\n", ""]);

// exports
